import { AffiliatePage } from './affiliate.component';
import { connect } from 'react-redux';
import { affiliateCreate } from './../../api/affiliate/affiliateAction';

const mapDispatchToProps = {
    affiliateCreate
};

const mapStateToProps = state => ({
    isLoading: state.affiliatePage.isLoading,
    isSaved: state.affiliatePage.isSaved
});

export const AffiliateContainer = connect(mapStateToProps, mapDispatchToProps)(AffiliatePage);